export default __webpack_public_path__ + "static/media/kotlin.4f592da4.svg";